<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <v-layout wrap>
          <v-flex xs6 style="padding: 10px">
            <v-layout wrap>
              <v-flex xs6 style="padding-right: 10px">
                <i-datepicker
                    value=""
                    label="Nhập ngày muốn kiểm tra"
                    clearable
                    @clearText="clearFromDate"
                    @change="onChangeFromDate"
                />
              </v-flex>
<!--              <v-flex xs6>
                <i-datepicker
                    value=""
                    label="Đến ngày"
                    clearable
                    @clearText="clearToDate"
                    @change="onChangeToDate"
                />
              </v-flex>-->
            </v-layout>
          </v-flex>
        </v-layout>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="id"
            search-url="/kidOrderClass/searchAll?sortField=status,id&"
            create-url="/kidOrderClass/save"
            delete-url="/kidOrderClass/delete"
            form-type="intable"
            custom-create-new
            custom-edit-item
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="true"
            :accept-edit="false"
            :accept-create="false"
            :acceptExport="4"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/topic/TopicCreate";
import {statusMHBL} from "@/constants/areaConstants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Kid order math",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      programName: null,
      programId: null,
      ageId: null,
      ageName: null,
      levelNumber: null,
      levelId: null,
      fromDate: null,
      toDate: null,
      weekTotal: null,
      hiddenFields: {
        typeId: "0",
        fromDate: null,
        toDate: null,
      },
      fields: [
        {
          value: "id",
          text: "id",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'packageId',
          text: 'package_id',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 60px;",
        },
        {
          value: 'accountId',
          text: 'account_id',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'name',
          text: 'name',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 70px;",
        },
        {
          value: 'phone',
          text: 'phone',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'address',
          text: 'address',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 70px;",
        },
        {
          value: 'price',
          text: 'price',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'ship',
          text: 'ship',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'total',
          text: 'total',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'type',
          text: 'type',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'source',
          text: 'source',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'deviceType',
          text: 'device_type',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'step',
          text: 'step',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'createdAt',
          text: 'created_at',
          sortable: false,
          search: false,
          dateFormat: 'dd/MM/yyyy hh:mm',
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'updatedAt',
          text: 'updated_at',
          sortable: false,
          search: false,
          dateFormat: 'dd/MM/yyyy hh:mm',
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'campaignName',
          text: 'campaign_name',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          type: "select",
          name: "status",
          value: 'status',
          text: 'Trạng thái',
          sortable: false,
          search: true,
          headerStyle: "text-align:center ;width: 130px;",
          itemText: "status",
          itemValue: "value",
          items: [
            {value: 1, status: 'All user'},
            {value: 2, status: 'Vip User'},
            {value: 3, status: 'Vip User Học Thử'},
            {value: 4, status: 'Vip User Tiếng Anh'},
            {value: 5, status: 'Non Vip User'},
            {value: 6, status: 'Non Vip User hoàn thành L1'},
            {value: 7, status: 'Non Vip User chưa hoàn thành L1'},
          ],
        },
      ],
    };
  },

  created() {
  },


  methods: {

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    clearFromDate() {
      this.hiddenFields.fromDate = new Date();
    },
    clearToDate() {
      this.hiddenFields.toDate = new Date();
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/tracking/view/' + item.userName,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
